// Odesílatel zprávy na bílou / černou listinu schránky (balík G) – nabídka „Odesílatel“ v seznamu i v okně zprávy.
// Jen schránka na našem serveru (listina rozhoduje při příjmu); server ověří přístup (plný přístup / správce pošty).
import { action, ApiError } from '@core/api';
import { t, tk } from '@core/i18n';
import { type MenuItem } from '@core/components/menu';
import { toast } from '@core/components/toast';
import type { Account } from './types';

/** Lze odesílatele této zprávy dát na listinu? (schránka u nás, zpráva s adresou odesílatele, ne jen ke čtení) */
export function senderListable(accounts: Account[], m: { account: string; fromEmail: string; readOnly?: boolean } | null | undefined): boolean {
  if (!m || m.readOnly || !m.fromEmail.includes('@')) return false;
  const acc = accounts.find((a) => a.id === m.account);
  return acc?.onServer === true && (acc.level === 'owner' || acc.level === 'full');
}

export function senderMenu(m: { id: string; fromEmail: string }): MenuItem[] {
  const email = m.fromEmail.toLowerCase();
  const domain = email.slice(email.lastIndexOf('@') + 1);
  const put = async (act: 'allow' | 'junk' | 'reject', what: 'email' | 'domain'): Promise<void> => {
    try {
      const r = await action<{ value: string; action: string }>('posta', 'posta', 'sender_list', {}, { id: m.id, action: act, what });
      toast(t('posta.listina.added_' + r.action, { value: r.value }), 'ok');
    } catch (e) { toast(tk((e as ApiError).message, (e as ApiError).params ?? undefined), 'error'); }
  };
  const block = (what: 'email' | 'domain', label: string): MenuItem[] => [
    { label, header: true },
    { label: t('posta.listina.m_allow'), icon: 'check', onSelect: () => void put('allow', what) },
    { label: t('posta.listina.m_junk'), icon: 'alert', onSelect: () => void put('junk', what) },
    { label: t('posta.listina.m_reject'), icon: 'x', danger: true, onSelect: () => void put('reject', what) },
  ];
  return [...block('email', email), { label: '', separator: true }, ...block('domain', t('posta.listina.m_domain', { domain }))];
}
